export default "__VITE_PUBLIC_ASSET__3e166712__"